import type {Ref} from "vue";
import type {AccessToken} from "./types";
import {useMateApi} from "./useMateApi";

export interface PosClassicVersionInfo {
    DBVersion: string;
    AssemblyVersion: string;
    DBUpdateInProgress: boolean;
    DBUpdateError: string | null;
    Edition: string;
}

export interface PosClassicPackagesVersionInfo {
    version: VersionSummary;
    translations: Translation[];
    packages: PosPackage[];
}

export interface PosPackage {
    fileName: string;
    size: number;
    utcModified: number;
    files: PosPackageFile[];
    // calculated fields
    fileCount?: number;
    sortedFiles?: Ref<PosPackageFile[]>;
}

export interface PosPackageFile {
    name: string;
    version: string;
    modified: string;
    required: boolean;
    size: number;
    compressedSize: number;
    crc: string;
    redundant: boolean;
    // calculated fields
    index?: number;
    
}

export interface VersionSummary {
    version: string;
    friendlyVersion: string;
    releaseDateTime: string;
    copyright: string;
    webAddress: string;
    edition: string;
}

export interface Translation {
    language: string;
    name: string;
    size: number;
    checksum: string;
}

export const usePosClassicInfoApi = (accessToken: AccessToken) => {

    const {jsonEndpoint} = useMateApi(accessToken);
    const api = jsonEndpoint("/api/posclassic");

    const getServerVersionInfo = () => api.get<PosClassicVersionInfo>({}, {url: "/version.json"});

    const getPackagesInfo = () => api.get<PosClassicPackagesVersionInfo>({}, {url: "/packages.json"});

    const getLogs = () => api.get<string>({}, {url: "/log"});

    return {
        getServerVersionInfo,
        getPackagesInfo,
        getLogs
    }
}
